import { createReducer, on, Action } from '@ngrx/store';
import * as fromModels from '@models';
import * as WorkbookActions from '@workbook/store/workbook.actions';

export const workbookFeatureKey = 'workbook';

export enum errorTypes {
  fetching = 'fetching',
  creating = 'creating',
  editing = 'editing',
  deleting = 'deleting',
}

export interface WorkbookState {
  collection: fromModels.Workbook[];
  row: fromModels.Workbook;
  error: Error;
  errorType: errorTypes;
  defaultView: fromModels.View;

  isFetching: boolean;
  hasError: boolean;
  successfullyAdded: boolean;
  successfullyEdited: boolean;
  successfullyDeleted: boolean;
  successfullyApplied: boolean;
}

export const initialState: WorkbookState = {
  collection: [],
  row: null,
  error: null,
  errorType: null,
  defaultView: null,

  isFetching: false,
  hasError: false,
  successfullyAdded: false,
  successfullyEdited: false,
  successfullyDeleted: false,
  successfullyApplied: false,
};

const workbookReducer = createReducer(
  initialState,

  // inicia la carga de los datos
  on(
    WorkbookActions.getViews,
    (state, payload) => {
      const auxRow = Object.assign({}, state.row, {views: []});
      return Object.assign({}, state, {
        isFetching: true,
        collection: [],
        row: auxRow,
        successfullyApplied: false,
      });
  }),
  // retorna los datos cargados
  on(WorkbookActions.viewsLoaded, (state, payload) => {
    const newRow = Object.assign({}, state.row, {views: payload.views});
    return Object.assign({}, state, {
      isFetching: false,
      row: newRow,
    });
  }),

  on(
    WorkbookActions.getDefaultView,
    (state, payload) => {
      return Object.assign({}, state, {
        isFetching: true,
        defaultView: null,
      });
  }),
  on(WorkbookActions.defaultViewLoaded, (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false,
      defaultView: payload.view,
    });
  }),

  on(
    WorkbookActions.getViews,
    (state, payload) => {
      const auxRow = Object.assign({}, state.row, {views: []});
      return Object.assign({}, state, {
        isFetching: true,
        collection: [],
        row: auxRow,
      });
  }),
  // retorna los datos cargados
  on(WorkbookActions.viewsLoaded, (state, payload) => {
    const newRow = Object.assign({}, state.row, {views: payload.views});
    return Object.assign({}, state, {
      isFetching: false,
      row: newRow,
    });
  }),

  on(
    WorkbookActions.setWorkbook,
    (state, payload) => {
      return Object.assign({}, state, {
        row: payload.workbook,
      });
  }),

  on(
    WorkbookActions.setOpeningType,
    (state, payload) => Object.assign({}, state, {
        isFetching: true, successfullyApplied: false,
      })
  ),

  on(
    WorkbookActions.setOpeningTypeResponse,
    (state, payload) => {
      return Object.assign({}, state, {
        isFetching: false, successfullyApplied: payload.success,
      });
  }),

  on(
    WorkbookActions.getWorkbook,
    (state, payload) => Object.assign({}, state, {
        isFetching: true, row: null,
      })
  ),

  on(
    WorkbookActions.getWorkbookSuccess,
    (state, payload) => {
      return Object.assign({}, state, {
        isFetching: false, row: payload.row,
      });
  }),

  // ocurrio un error
  on(WorkbookActions.failRequest, (state, payload) => (
    Object.assign({}, state, {
      hasError: true,
      row: null,
      error: payload.error,
      errorType: payload.errorType,
    })
  )),
);

export function reducer(state: WorkbookState | undefined, action: Action) {
  return workbookReducer(state, action);
}
